import React, { useState } from "react";
import '../../css/templates.css';
import FastEdit from './fastEdit';
import AddTemplate from './addTemplate';
import DetailedEdit from './detailedEdit';
import { deleteTemplate } from '../../utilities/templateFunctions.js';
import { useSelector } from 'react-redux';
import Icon from "../../assets/icons/icon.js";


function TextTemplates({ data,formatDate }) {
    const agentId=useSelector((state) => state.agent.userData).agentId;
    const [editingTemplate, setEditTemplate] = useState(false);
    const [addScript, setAddScript] = useState(false);
    const [transition, setTransition] = useState(false);
    const [editingItemId, setEditingItemId] = useState(null);
    const [newTemplate, setNewTemplate] = useState(null);

    const addAScript = () => {
        setAddScript(!addScript);
    };
    const editTemplate = (id,name,content, subject) => {
        if(id===false){
            setEditTemplate(false);
        }
        else{
            setEditTemplate({id:id,name:name,content:content, subject:subject});
        }
    };
   
    return (
        <div className="outerWrapper">
                <span className="outerWrapperTitle">
                    <span className="outerWrapperIcon">

                    </span>
                    Templates
                </span>
                <div
                    className="mainBlockOuterWrapper"
                    style={{ justifyContent: "space-around" }}
                >
            {editingTemplate ? (
                <DetailedEdit editTemplate={editTemplate} type='Text' editingTemplate={editingTemplate}/>
            ) : (
                null
            )}

            {addScript ? (
               <AddTemplate addATemplate={addAScript} setNewTemplate={setNewTemplate} type={'Text'}/>

            ):(
            null
            )}
            <div className={`frontPageQuilityParentBlockWrapper ${addScript ? 'closeMainBlock' : editingTemplate ? 'closeMainBlock' : ''}`} style={{width:'75%'}}>
                        <div className="quilityParentBlockHeader">
                            <div className="quilityParentBlockTitle">Text Messages</div>
                        </div>
                        <div className="quilityParentBlockContent">
                            {newTemplate == null ? '' : (
                                <div className={`quilityNestedBlockWrapper ${editingItemId === newTemplate.id ? 'focusBigBlock' : ''}`} key={'temp'} style={{marginTop: '25px'}}>
                                    <div className="quilityCloseWindow oulineQuilityDestructiveButton" >Xs</div>
                                    <div className="quilityNestedBlockHeader">
                                        <div className="quilityParentBlockTitle">
                                            {newTemplate.name}
                                        </div>
                                    </div>
                                    <div className="infoWrapper">
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Text Name: </span>
                                            {newTemplate.name}
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Content: </span>
                                            <FastEdit 
                                                item={newTemplate}
                                                index={'temp'}
                                                transition={transition}
                                                setTransition={setTransition}
                                                editingItemId={editingItemId}
                                                setEditingItemId={setEditingItemId}
                                                type={'Text'}
                                                name={newTemplate.name}
                                                editTemplate={editTemplate}
                                            />
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Date Created: </span>
                                            Just Now
                                        </div>
                                    </div>
                                </div>
                            )}
                            {data[0].type !== false && data[0].map((item, index) => (    
                                <div className={`quilityNestedBlockWrapper ${editingItemId === item.id ? 'focusBigBlock' : ''}`} key={`textTemplates${index}`} style={{marginTop: '25px'}}>
                                   <div className="quilityCloseWindow" style={{top: '0px'}}><span className="fontello" style={{marginTop: '-7px'}} onClick={()=>deleteTemplate("Text", item.id, agentId)}><Icon name={'x-circle-q'} size={34} className="closeIcon" adjust="fontello" /></span></div>
                                    <div className="quilityNestedBlockHeader">
                                        <div className="quilityParentBlockTitle">
                                            {item.name}
                                        </div>
                                    </div>
                                    <div className="infoWrapper">
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Text Name: </span>
                                            {item.name}
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Content: </span>
                                            <FastEdit 
                                                item={item}
                                                index={index}
                                                transition={transition}
                                                setTransition={setTransition}
                                                editingItemId={editingItemId}
                                                setEditingItemId={setEditingItemId}
                                                type={'Text'}
                                                name={item.name}
                                                editTemplate={editTemplate}
                                            />
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Date Created: </span>
                                            {formatDate(item.created)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {data[0].type === false && newTemplate != null < 1 && (
                                <div className="title">You have no templates</div>
                            )}
                        </div>
                        <div className="blockFooter">
                            <div
                                className="buttonWrapper"
                                style={{ marginTop: " 5px", marginLeft: "10px" }}
                            >
                                <div className="dataButtonBlock">Texts: {data[0].length ? data[0].length : 0}</div>
                                <div className="actionButtonBlock">
                                    <div className="accentButton solidQuilityActiveButton" onClick={()=>addAScript()}>
                                    +  New Text
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
        </div>

    );
}

export default TextTemplates;

